// extracted by mini-css-extract-plugin
module.exports = {"input":"SInput_input__1HFhY","fntLable":"SInput_fntLable__2tr7G","prefix":"SInput_prefix__2txwF"};